import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useIntercom } from 'react-use-intercom';
import { useAuth } from 'context/AuthContext/AuthContext';
import { isProductionBuild } from 'utils/env';

/*
  A custom hook to boot Intercom and update on route changes.
  Enabling Intercom to check for any new messages to send to the user. 
*/
function useIntercomSync() {
  const location = useLocation();
  const { email } = useAuth();
  const { update, boot } = useIntercom();

  useEffect(() => {
    if (isProductionBuild) {
      boot();
    }
  }, [boot]);

  useEffect(() => {
    if (isProductionBuild) {
      update({ email });
    }
  }, [location, update, email]);
}

export default useIntercomSync;
